export const ENTITY_PATH = 'medias';

export const MAX_FILE_SIZE = 15 * Math.pow(2, 20);
